<template>
    <transition  >
    <div class="container-fluid ">
        <div class="row">
                <div class="col-12">
                    <div class="page-title-box">
                        <div class="page-title-right float-left">
                            <ol class="breadcrumb m-0"> 
                                <li class="breadcrumb-item active">Diagnosis Billing </li>
                                <li class="breadcrumb-item"><a href="javascript: void(0);">Add Diagnosis Billing</a></li>
                                
                            </ol>
                        </div>
                    </div>
                </div>
            </div>  
            <div class="row">
                <div class="col-12">
                    <!-- Search and export area -->
                    <div class="card">
                        <div class="card-header">
                            <h3 style="text-align: left;">New Billing</h3>
                        </div>

                        <div class="card-body">   
                            <form v-if="!loading">
                                <!-- Bill Information -->
                                <div class="row mb-3">
                                    <div class="col-md-12">
                                        <h4 class="wpr_general_sign_title">Invoice, Patient information and Other's </h4>
                                    </div>

                                    <div class="col-md-12">
                                        <div class="row">
                                            <div class="col-md-6 mb-1">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label for="bill_no" style="width: 100%; height: 34px; padding: 10px;">Invoice No <span style="color: red">*</span></label>
                                                    </div>
                                                    <div class="col-md-8">
                                                        <input type="text" class="form-control border" v-model="form.bill_no" placeholder="Enter Bill No"  @keypress="onkeyPress('bill_no')">
                                                        <div class="invalid-feedback" v-if="errors.bill_no">
                                                            {{errors.bill_no[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6 mb-1">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label for="bill_date" style="width: 100%; height: 34px; padding: 10px;">Invoice Date  <span style="color: red">*</span></label>
                                                    </div>
                                                    <div class="col-md-8">
                                                        <input type="date" class="form-control border" v-model="form.bill_date" placeholder="Enter Date" @keypress="onkeyPress('bill_date')">
                                                        <div class="invalid-feedback" v-if="errors.bill_date">
                                                            {{errors.bill_date[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6 mb-1">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label for="patient_name" style="width: 100%; height: 34px; padding: 10px;">Patient Name  <span style="color: red">*</span></label>
                                                    </div>
                                                    <div class="col-md-8">
                                                        <template v-if="patients.length > 0">
                                                            <Multiselect 
                                                                class="form-control border" 
                                                                mode="single"
                                                                v-model="search_patient_id"
                                                                placeholder="Select Patient"  
                                                                :searchable="true" 
                                                                :filter-results="true"
                                                                :options="patient_options"
                                                                :classes="multiclasses"
                                                                :close-on-select="true" 
                                                                :min-chars="1"
                                                                :resolve-on-load="false" 
                                                                :create-option="true" 
                                                                ref="patientMultiselect"
                                                                @change="changePatient"
                                                                v-if="renderOptionComponent"
                                                            />
                                                        </template>
                                                        <template v-else>
                                                            <input type="text" class="form-control border" v-model="form.patient_name" placeholder="Enter Patient Name" @keypress="onkeyPress('patient_name')">
                                                        </template>
                                                        <div class="invalid-feedback" v-if="errors.patient_name">
                                                            {{errors.patient_name[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6 mb-1">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label for="patient_phone" style="width: 100%; height: 34px; padding: 10px;">Patient Phone <span style="color: red">*</span></label>
                                                    </div>
                                                    <div class="col-md-8">
                                                        <input
                                                            type="text"
                                                            class="form-control border"
                                                            v-model="form.patient_phone"
                                                            placeholder="Enter Patient Phone"
                                                            @keypress="onkeyPress('patient_phone')"
                                                            @input="form.patient_phone = form.patient_phone.replace(/[^0-9]/g, '').slice(0, 11)"
                                                            @keyup="getPatientByPhone($event)"
                                                        >
                                                        <div class="invalid-feedback" v-if="errors.patient_phone">
                                                            {{errors.patient_phone[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6 mb-1">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label for="patient_age" style="width: 100%; height: 34px; padding: 10px;">Patient Age <span style="color: red"></span></label>
                                                    </div>
                                                    <div class="col-md-8">
                                                        <div class="d-flex gap-2">
                                                            <input type="number"
                                                                class="form-control"
                                                                placeholder="Years"
                                                                min="0"
                                                                v-model.number="age.years"
                                                                @input="validateAge('years'), updateAge()">

                                                            <input type="number"
                                                                class="form-control"
                                                                placeholder="Months"
                                                                min="0"
                                                                max="11"
                                                                v-model.number="age.months"
                                                                @input="validateAge('months'), updateAge()">

                                                            <input type="number"
                                                                class="form-control"
                                                                placeholder="Days"
                                                                min="0"
                                                                max="30"
                                                                v-model.number="age.days"
                                                                @input="validateAge('days'), updateAge()">
                                                        </div>

                                                        <!-- Hidden / Readonly Final Value -->
                                                        <input type="hidden" v-model="form.patient_age">
                                                        <!-- <input type="number" class="form-control border" v-model="form.patient_age" placeholder="Enter Patient Age" @keypress="onkeyPress('patient_age')"> -->

                                                        <small class="text-muted">
                                                            {{ form.patient_age ?? '' }}
                                                        </small>
                                                        <div class="invalid-feedback" v-if="errors.patient_age">
                                                            {{errors.patient_age[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6 mb-1">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label for="patient_gender" style="width: 100%; height: 34px; padding: 10px;">Gender <span style="color: red"></span></label>
                                                    </div>
                                                    <div class="col-md-8">
                                                        <Multiselect 
                                                            class="form-control border" 
                                                            mode="single"
                                                            v-model="form.patient_gender"
                                                            placeholder="Gender"  
                                                            :searchable="true" 
                                                            :filter-results="true"
                                                            :options="gender_options"
                                                            :classes="multiclasses"
                                                            :close-on-select="true" 
                                                            :min-chars="1"
                                                            :resolve-on-load="false" 
                                                            :create-option="false"
                                                            @change="onkeyPress('patient_gender')"
                                                            v-if="renderOptionComponent"
                                                        />  
                                                        <div class="invalid-feedback" v-if="errors.patient_gender">
                                                            {{errors.patient_gender[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6 mb-1">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label for="reference_type" style="width: 100%; height: 34px; padding: 10px;">Reference Type <span style="color: red">*</span></label>
                                                    </div>
                                                    <div class="col-md-8">
                                                        <Multiselect 
                                                            class="form-control border" 
                                                            mode="single"
                                                            v-model="form.reference_type"
                                                            placeholder="Select Reference Type"  
                                                            :searchable="true" 
                                                            :filter-results="true"
                                                            :options="[{label:'Doctor', value:'doctor'}, {label:'Self', value:'self'}, {label:'Others', value:'others'}]"
                                                            :classes="multiclasses"
                                                            :close-on-select="true" 
                                                            :min-chars="1"
                                                            :resolve-on-load="false" 
                                                            :create-option="false" 
                                                            v-if="renderOptionComponent"
                                                        />                                                   
                                                        <div class="invalid-feedback" v-if="errors.reference_type">
                                                            {{errors.reference_type[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6 mb-1">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label for="reference_person_id" style="width: 100%; height: 34px; padding: 10px;">Reference Person <span style="color: red">*</span></label>
                                                    </div>
                                                    <div class="col-md-8">
                                                        <input type="hidden" class="form-control border" v-model="form.reference_person_name">
                                                        <div class="input-group input-group-merge">  
                                                            <Multiselect 
                                                                class="form-control border" 
                                                                mode="single"
                                                                v-model="form.reference_person_id"
                                                                placeholder="Select Reference"  
                                                                :searchable="true" 
                                                                :filter-results="true"
                                                                :options="doctor_options"
                                                                :classes="multiclasses"
                                                                :close-on-select="true" 
                                                                :min-chars="1"
                                                                :resolve-on-load="false"
                                                                :create-option="true" 
                                                                @change="changeReferencePerson"
                                                                v-if="renderOptionComponent"
                                                            />
                                                            <div class="input-group-text">
                                                                <a @click="doctorAddModal()">
                                                                    <i class="fas fa-plus-circle"></i>
                                                                </a>
                                                            </div>
                                                        </div>                                                   
                                                        <div class="invalid-feedback" v-if="errors.reference_person_id">
                                                            {{errors.reference_person_id[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6 mb-1">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label for="delivery_date" style="width: 100%; height: 34px; padding: 10px;">Date of Delivery  <span style="color: red">*</span></label>
                                                    </div>
                                                    <div class="col-md-8">
                                                        <input type="date" class="form-control border" v-model="form.delivery_date" @change="changeDeliveryDateTime(), onkeyPress('delivery_date')" placeholder="Enter Date">
                                                        <div class="invalid-feedback" v-if="errors.delivery_date">
                                                            {{errors.delivery_date[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                        </div>

                                        <hr>

                                        <!-- Diagnosis Test Information -->
                                        <div class="item_area" style="padding: 10px; border: 1px solid #e0e0e0;">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <h4 class="wpr_general_sign_title">Test Items</h4>
                                                </div>
                                            </div>

                                            <div class="row">      
                                                <div class="col-md-3"></div>                  
                                                <div class="col-md-6">
                                                    <div class="mb-1">
                                                        <div class="form-group autocomplete">
                                                            <input
                                                                type="text"
                                                                v-model="searchTerm"
                                                                class="form-control"
                                                                placeholder="Scan/Search Test by name"
                                                                @keyup="inputChanged"
                                                                @keyup.enter="getTestByName()"  
                                                                @keydown.down="onArrowDown" 
                                                                @keydown.up="onArrowUp"
                                                                
                                                            />
                                                            <div class="invalid-feedback" v-if="errors.searchTerm">
                                                                {{errors.searchTerm[0]}}
                                                            </div>
                                                            <ul
                                                                v-if="searchTests.length"
                                                                class="w-full rounded bg-white border border-gray-300 px-4 py-2 space-y-1 absolute z-10 autocomplete-results"
                                                            >
                                                                <li>
                                                                    Showing {{ searchTests.length }} of {{ test_items.length }} results
                                                                </li>
                                                                <li
                                                                v-for="(item, i) in searchTests.slice(0, 15)"
                                                                :key="item.name"
                                                                @change="selectTests(item)"
                                                                @click="setResult(item)"
                                                                class="cursor-pointer hover:bg-gray-100 p-1"
                                                                :class="{ 'is-active': i === arrowCounter }"
                                                                >
                                                                {{ item.name }}
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>    
                                                </div>
                                                <div class="col-md-3"></div>
                                            </div>

                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="table-responsive" style="padding: 0;">
                                                        <table class="table table-bordered table-centered mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th width="5%">SL</th>
                                                                    <th width="35%">Test/Service</th>
                                                                    <th width="10%">Qty</th>
                                                                    <th width="10%">Rate</th>
                                                                    <th width="10%">Disc%</th>
                                                                    <!-- <th width="7%">Flat Disc</th> -->
                                                                    <th width="10%">Total</th>
                                                                    <th width="15%">Delivery Date/Time</th>
                                                                    <th width="5%">Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(item, index) in form.ptest_items" :key="index">
                                                                    <td>{{index+1}}</td>
                                                                    <td>{{item.name}}</td>                                                    
                                                                    <td><input type="number" class="form-control" v-model="item.qty"></td>
                                                                    <td>{{item.price}}</td>
                                                                    <td><input type="number" class="form-control" v-model="item.discount"></td>
                                                                    <!-- <td><input type="number" class="form-control" v-model="item.flat_discount"></td> -->
                                                                    <!-- <td class="text-right" v-if="item.discount > 0 || item.flat_discount > 0">{{ (item.price * item.qty) - ((((item.price * item.qty) * item.discount) / 100) + item.flat_discount ) }}</td> -->
                                                                    <td class="text-right" v-if="item.discount > 0">{{ (item.price * item.qty) - (((item.price * item.qty) * item.discount) / 100) }}</td>
                                                                    <td class="text-right" v-else>{{ (item.price * item.qty) }}</td>
                                                                    <td class="text-right"><input type="text" class="form-control" style="padding: 5px 5px;" v-model="item.delivery_datetime"></td>
                                                                    <td>
                                                                        <button type="button" class="btn btn-danger btn-sm" @click="removeTestListItem(index)">
                                                                            <i class="fas fa-trash"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <hr>

                                <!-- Payment and Discount  -->
                                <div class="row mb-3">
                                    <div class="col-md-6" style="border-right: 1px solid #e0e0e0;">
                                        <!-- Reagent Items -->
                                        <h4 style="padding-bottom: 5px; border-bottom: 1px solid #e0e0e0; display: none;">Reagent and Accesories: </h4>
                                        <div class="table-responsive" style="padding: 0; display: none;">
                                            <table class="table table-bordered table-centered mb-0">
                                                <thead>
                                                    <tr>
                                                        <th width="5%">SL</th>
                                                        <th width="50%">Reagent/Accesories</th>
                                                        <th width="10%">Qty</th>
                                                        <th width="10%">Rate</th>
                                                        <th width="10%">Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index) in form.ptest_reagent_items" :key="index">
                                                        <td>{{index+1}}</td>
                                                        <td>{{item.name}}</td>                                                    
                                                        <td><input type="number" class="form-control" v-model="item.qty"></td>
                                                        <td>{{item.price}}</td>
                                                        <td class="text-right">{{ item.price * item.qty }}</td>
                                                        <!-- <td>
                                                            <button type="button" class="btn btn-danger btn-sm" @click="removeTestListItem(index)">
                                                                <i class="fas fa-trash"></i>
                                                            </button>
                                                        </td> -->
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <!-- Stationery Items -->
                                        <h4 style="padding-bottom: 5px; border-bottom: 1px solid #e0e0e0; display: none;">Stationery Items: </h4>
                                        <div class="table-responsive" style="padding: 0; display: none;">
                                            <table class="table table-bordered table-centered mb-0">
                                                <thead>
                                                    <tr>
                                                        <th width="5%">SL</th>
                                                        <th width="50%">Item</th>
                                                        <th width="10%">Qty</th>
                                                        <th width="10%">Rate</th>
                                                        <th width="10%">Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index) in form.ptest_stequipment_items" :key="index">
                                                        <td>{{index+1}}</td>
                                                        <td>{{item.name}}</td>                                                    
                                                        <td><input type="number" class="form-control" v-model="item.qty"></td>
                                                        <td>{{item.price}}</td>
                                                        <td class="text-right">{{ item.price * item.qty }}</td>
                                                        <!-- <td>
                                                            <button type="button" class="btn btn-danger btn-sm" @click="removeTestListItem(index)">
                                                                <i class="fas fa-trash"></i>
                                                            </button>
                                                        </td> -->
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <!-- Room Numbers -->
                                        <h4 style="padding-bottom: 5px; border-bottom: 1px solid #e0e0e0;">Room Numbers: </h4>
                                        <div class="room_numbers" style="padding: 0;">
                                            <button type="button" class="btn btn-dark btn-sm" style="margin: 2px;" v-for="(item, index) in form.room_numbers" :key="index"> {{ item }}</button>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <!-- Apply Discount -->
                                        <div class="row">
                                            <div class="col-md-12">
                                                <h4 style="padding-bottom: 5px; border-bottom: 1px solid #e0e0e0;">Apply Discounts (%)</h4>
                                                <ul class="discount_items">
                                                    <li v-for="(item, index) in discount_items" :key="index">
                                                        <div class="form-check">
                                                            <input type="checkbox" class="form-check-input" :id="item.id" v-model="item.is_checked" @input="applyDiscount(index, item)" />
                                                            <label class="form-check-label" :for="item.id">{{ item.name }}</label>
                                                            <div class="discount_fields" v-if="item.is_checked">
                                                                <div class="item_field" v-if="item.name.toLowerCase().includes('corporate')">
                                                                    <input type="text" v-model="item.discount_flat_val" class="form-control" v-if="item.discount_flat_val > 0">
                                                                    <input type="text" v-model="item.discount_percent" class="form-control" @input="changeApplyDiscount(index, item)" v-else>

                                                                    <input type="text" v-model="form.corporate_company_name" class="form-control" placeholder="Company Name">
                                                                    <input type="text" v-model="form.corporate_employee_id" class="form-control" placeholder="Employee ID">
                                                                    <input type="text" v-model="form.corporate_employee_name" class="form-control" placeholder="Employee Name">
                                                                </div>
                                                                <div class="item_field" v-else>
                                                                    <input type="text" v-model="item.discount_flat_val" class="form-control" v-if="item.discount_flat_val > 0">
                                                                    <input type="text" v-model="item.discount_percent" class="form-control" @input="changeApplyDiscount(index, item)" v-else>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                        <hr>

                                        <div class="payment_amount_area">
                                            <table class="table-sm table table-bordered border" style="margin-bottom: 15px">
                                                <thead class="tableFloatingHeaderOriginal">
                                                    <tr class="item-head">
                                                        <th>Total Item</th>
                                                        <th width="40%" style="text-align: right;">{{ Number(form.ptest_items.length).toLocaleString() }}</th>
                                                    </tr>
                                                    <tr class="border item-head">
                                                        <th>Total</th>
                                                        <th style="text-align: right;">
                                                            {{  Number(totalCartValue)
                                                                .toLocaleString(undefined, {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                }) 
                                                            }}
                                                        </th> 
                                                    </tr>
                                                    <tr class="item-head">
                                                        <th>Discount ( {{ totalDiscountPercent - totalExtraDiscountPercent }} %) </th>
                                                        <th style="text-align: right;">
                                                            {{ Number(totalGeneralDiscount)
                                                                .toLocaleString(undefined, {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                })
                                                            }}
                                                        </th>
                                                    </tr>
                                                    
                                                    <tr class="item-head">
                                                        <th>Extra Discount</th>
                                                        <th style="text-align: right;">
                                                            {{ Number(totalExtraDiscount + totalFlatDiscount)
                                                                .toLocaleString(undefined, {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                }) 
                                                            }}
                                                        </th>
                                                    </tr>
                                                    
                                                    <tr class="item-head">
                                                        <th>Payable Amount</th>
                                                        <th style="text-align: right;">
                                                            {{ Number(netAmountCalculate)
                                                                .toLocaleString(undefined, {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                }) 
                                                            }}
                                                        </th>
                                                    </tr>
                                                    
                                                    <tr class="item-head">
                                                        <th>Received Amount</th>
                                                        <th style="text-align: right;">
                                                            <input type="number" step="any" scrolling="no" v-model="form.received_amount" class="form-control" style="text-align: right;">
                                                        </th>
                                                    </tr>
                        
                                                    <tr class="item-head">
                                                        <th>Due Amount</th>
                                                        <th style="text-align: right;">
                                                            {{ (netAmountCalculate > form.received_amount) 
                                                                ? Number(netAmountCalculate - form.received_amount)
                                                                    .toLocaleString(undefined, {
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2
                                                                    }) 
                                                                : Number(0)
                                                                    .toLocaleString(undefined, {
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2
                                                                    }) 
                                                            }}
                                                        </th>
                                                    </tr>
                                                </thead>
                                            </table>

                                        </div>
                                    </div>
                                </div>

                                <hr>

                                <div class="row">
                                    <div class="col-md-5"></div>
                                    <div class="col-md-4"></div>
                                    <div class="form-group col-md-4" style="text-align: right; display: none;">
                                        <!-- <label for="cost_center_id">Cost Center </label><br> -->
                                        <treeselect 
                                            v-model="form.cost_center_id"
                                            :multiple="false" 
                                            :always-open="false"
                                            :options="costCenterOptions"
                                            :value-consists-of="valueConsistsOf"
                                            :normalizer="normalizer"
                                            :default-expand-level="Infinity"
                                            :disable-branch-nodes="true"
                                            :search-nested="true"                                                
                                            placeholder='Select Cost Center'
                                            v-if="renderOptionComponent"
                                        />
                                        <div class="invalid-feedback" v-if="errors.cost_center_id">
                                            {{errors.cost_center_id[0]}}
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="action_btn" style="text-align: right;">
                                            <!-- <button type="button" class="btn btn-sm btn-danger" id="reset" @click="toggleModal()" style="margin-right: 10px;">
                                                RESET
                                            </button>

                                            <button type="button" class="btn btn-sm btn-warning" id="clear-cart-item" @click="clearAllCartItems" style="margin-right: 10px;">
                                                Clear Item
                                            </button> -->

                                            <button type="button" class="btn btn-sm btn-info" id="invoice-preview" @click="invoicePreviewModal" style="margin-right: 10px;">
                                                Invoice Preview
                                            </button> 

                                            <button type="button" class="btn btn-sm btn-primary " :disabled="disabled" @click.prevent="submitForm()">
                                                <span v-show="isSubmit">
                                                    <i class="fas fa-spinner fa-spin" ></i>
                                                </span> SUBMIT
                                            </button> 
                                        </div>
                                    </div>
                                </div>
                            </form>

                            <div class="tab-pane show active" v-if="loading">
                                <div class="row"> 
                                    <div class="col-md-5">  
                                    </div>
                                    <div class=" col-md-2"> 
                                        <img src="../../../assets/image/loading.gif" alt="Loading..." style="width:130px">
                                    </div>
                                    <div class="col-md-5">  
                                    </div>
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
            </div> 

            <!-- Doctor Add Modal -->
            <Modal @close="toggleDoctorModal()" :modalActive="doctorAddModalActive">
                <div class="modal-content scrollbar-width-thin">
                    <div class="modal-header"> 
                        <h3>Doctor Create</h3>
                        <button @click="toggleDoctorModal()" type="button" class="btn btn-default">X</button>
                    </div>
                    <form @submit.prevent="submitDoctorForm()" enctype="multipart/form-data" >
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="row  ">
                                        <!-- <div class="form-group col-md-4">
                                            <div class="mb-3">
                                                <label for="doctor_code">Doctor Code *</label>
                                                <input type="text" class="form-control border " @keypress="onkeyPress('doctor_code')" v-model="dform.doctor_code" id="doctor_code" placeholder="Doctor Code" autocomplete="off"> 
                                                <div class="invalid-feedback" v-if="errors.doctor_code">
                                                    {{errors.doctor_code[0]}}
                                                </div>
                                            </div>
                                        </div> -->

                                        <div class="form-group col-md-6">
                                            <div class="mb-3">
                                                <label for="company_id">Company *</label> 
                                                <select class="form-control border" v-model="dform.company_id" @change="onkeyPress('company_id')" id="company_id">
                                                    <option value="0">Select company</option>
                                                    <option v-for="(company, index) in companies" :value="company.id" :key="index">
                                                        {{company.name}}
                                                    </option>
                                                </select> 
                                                <div class="invalid-feedback" v-if="errors.company_id">
                                                    {{errors.company_id[0]}}
                                                </div>
                                            </div>
                                        </div> 

                                        <div class="form-group col-md-6">
                                            <label for="department_id" style="float: none;">Doctor Department *</label> 
                                            <Multiselect 
                                                class="form-control border" 
                                                mode="single"
                                                v-model="dform.department_id"
                                                placeholder="Select Department"  
                                                :searchable="true" 
                                                :filter-results="true"
                                                :options="departments"
                                                :classes="multiclasses"
                                                :close-on-select="true" 
                                                :min-chars="1"
                                                :resolve-on-load="false" 
                                                :create-option="true" 
                                            />   
                                            <div class="invalid-feedback" v-if="errors.department_id">
                                                {{errors.department_id[0]}}
                                            </div>
                                        </div> 
                                    </div>

                                    <div class="row ">
                                        <div class="form-group col-md-4">
                                            <div class="mb-3">
                                                <label for="first_name">First Name *</label>
                                                <input type="text" class="form-control border"  @keypress="onkeyPress('first_name')" @keyup="ledgerAccountNameSetup($event.target.value)" v-model="dform.first_name" id="first_name" placeholder="First Name" autocomplete="off"> 
                                                <div class="invalid-feedback" v-if="errors.first_name">
                                                    {{errors.first_name[0]}}
                                                </div>
                                            </div>
                                        </div> 
                                        <div class="form-group col-md-4">
                                            <div class="mb-3">
                                                <label for="last_name">Last Name *</label>
                                                <input type="text" class="form-control border" @keypress="onkeyPress('last_name')" v-model="dform.last_name" id="last_name" placeholder="Last Name" autocomplete="off"> 
                                                <div class="invalid-feedback" v-if="errors.last_name">
                                                    {{errors.last_name[0]}}
                                                </div>
                                            </div>
                                        </div> 
                                        <div class="form-group col-md-4">
                                            <div class="mb-3">
                                                <label for="email">Email *</label>
                                                <input type="text" class="form-control border " @keypress="onkeyPress('email')" v-model="dform.email" id="email" placeholder="Doctor Email" autocomplete="off"> 
                                                <div class="invalid-feedback" v-if="errors.email">
                                                    {{errors.email[0]}}
                                                </div>
                                            </div>
                                        </div> 
                                    </div>

                                    <div class="row">
                                        <div class="form-group col-md-4">
                                            <div class="mb-3">
                                                <label for="phone">Phone *</label>
                                                <input type="text" class="form-control border" @keypress="onkeyPress('phone')" v-model="dform.phone" id="phone" placeholder="Doctor mobile number"> 
                                                <div class="invalid-feedback" v-if="errors.phone">
                                                    {{errors.phone[0]}}
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="form-group col-md-4">
                                            <div class="mb-3">
                                                <label for="designation">Designation *</label>
                                                <input type="text" class="form-control border" @keypress="onkeyPress('designation')" v-model="dform.designation" id="designation" placeholder="Designation"> 
                                                <div class="invalid-feedback" v-if="errors.designation">
                                                    {{errors.designation[0]}}
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="form-group col-md-4">
                                            <div class="mb-3">
                                                <label for="qualification">Qualification *</label>
                                                <input type="text" class="form-control border" @keypress="onkeyPress('qualification')" v-model="dform.qualification" id="qualification" placeholder="Qualification"> 
                                                <div class="invalid-feedback" v-if="errors.qualification">
                                                    {{errors.qualification[0]}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <div class="mb-3">
                                                    <label for="specialist">Specialist *</label>
                                                    <input type="text" class="form-control border" @keypress="onkeyPress('specialist')" v-model="dform.specialist" id="specialist" placeholder="Specialist"> 
                                                    <div class="invalid-feedback" v-if="errors.specialist">
                                                        {{errors.specialist[0]}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-8">
                                            <div class="row">
                                                <div class="form-group col-md-4">
                                                    <div class="mb-3">
                                                        <label for="dob">Date of Birth </label>
                                                        <input type="date" class="form-control border " @keypress="onkeyPress('dob')" v-model="dform.dob" id="dob" placeholder="" autocomplete="off"> 
                                                        <div class="invalid-feedback" v-if="errors.dob">
                                                            {{errors.dob[0]}}
                                                        </div>
                                                    </div>
                                                </div> 

                                                <div class="form-group col-md-4">
                                                    <div class="mb-3">
                                                        <label for="blood_group">Blood Group </label> 
                                                        <select class="form-control border" v-model="dform.blood_group" @change="onkeyPress('blood_group')" id="blood_group">
                                                            <option value="null" selected>Select Blood Group</option>
                                                            <option value="A+">A+</option>
                                                            <option value="A-">A-</option>
                                                            <option value="AB+">AB+</option>
                                                            <option value="AB-">AB-</option>
                                                            <option value="B+">B+</option>
                                                            <option value="B-">B-</option>
                                                            <option value="O+">O+</option>
                                                            <option value="O-">O-</option>

                                                        </select> 
                                                        <div class="invalid-feedback" v-if="errors.blood_group">
                                                            {{errors.blood_group[0]}}
                                                        </div>
                                                    </div>
                                                </div> 

                                                
                                                <div class="form-group col-md-4">
                                                    <div class="mb-3">
                                                        <label for="gender">Gender *</label>
                                                        <select class="form-control border" v-model="dform.gender" @change="onkeyPress('gender')">
                                                            <option value="male">Male</option>
                                                            <option value="female">Female</option>
                                                        </select>
                                                        <div class="invalid-feedback" v-if="errors.gender">
                                                            {{errors.gender[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>

                                    <!-- <div class="row">
                                        <div class="form-group col-md-3">
                                            <div class="mb-3">
                                                <label for="status">Status *</label>
                                                <select class="form-control border" v-model="dform.status" @change="onkeyPress('status')">
                                                    <option value="1">Active</option>
                                                    <option value="0">Inactive</option>
                                                </select>
                                                <div class="invalid-feedback" v-if="errors.status">
                                                    {{errors.status[0]}}
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="form-group col-md-3"> 
                                            <div class="mb-3" style="text-align: right;">
                                                <label for="create_user" style="width: 100%">&nbsp;&nbsp;</label>
                                                <input type="checkbox" class="form-check-input border " @change="onkeyPress('create_user')" true-value="1" false-value="0" v-model="dform.create_user" id="create_user"><b> Create User</b>
                                                <div class="invalid-feedback" v-if="errors.create_user">
                                                    {{errors.create_user[0]}}
                                                </div>
                                            </div>
                                        </div>  
                                        <div class="form-group col-md-3" v-if="form.create_user == 1"> 
                                            <div class="mb-3">
                                                <label for="password">Password *</label>
                                                <input type="password" class="form-control border" @keypress="onkeyPress('password')" v-model="dform.password" id="password" placeholder="Password" autocomplete="off"> 
                                                <div class="invalid-feedback" v-if="errors.password">
                                                    {{errors.password[0]}}
                                                </div>
                                            </div>
                                        </div>  
                                        <div class="form-group col-md-3" v-if="form.create_user == 1"> 
                                            <div class="mb-3">
                                                <label for="password_confirmation">Confirm Password *</label>
                                                <input type="password" class="form-control border" @keypress="onkeyPress('password_confirmation')" v-model="dform.password_confirmation" id="password_confirmation" placeholder="Confirm Password" autocomplete="off"> 
                                                <div class="invalid-feedback" v-if="errors.password_confirmation">
                                                    {{errors.password_confirmation[0]}}
                                                </div>
                                            </div>
                                        </div>                                    
                                    </div> -->

                                    <div class="row">
                                        <div class="form-group col-md-3">
                                            <div class="mb-3">
                                                <label for="commission_percentage">Commission Percent</label> 
                                                <input type="number" class="form-control" @keypress="onkeyPress('commission_percentage')" v-model="dform.commission_percentage" id="commission_percentage" placeholder="Commission Percent" autocomplete="off">
                                                <div class="invalid-feedback" v-if="errors.commission_percentage">
                                                    {{errors.commission_percentage[0]}}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group col-md-6"> 
                                            <div class="mb-3">
                                                <label for="description">Description</label>
                                                <textarea class="form-control border" @keypress="onkeyPress('description')" v-model="dform.description" id="description" placeholder="Description" autocomplete="off"></textarea> 
                                                <div class="invalid-feedback" v-if="errors.description">
                                                    {{errors.description[0]}}
                                                </div>
                                            </div>
                                        </div> 
                                        <div class="form-group col-md-3">
                                            <div class="form-group">
                                                <label style="width: 100%">Image (128X128)</label> <br>
                                                <div class="fileinput fileinput-new" data-provides="fileinput" style="position: relative;">
                                                <span class="btn btn-block btn-primary btn-file"><span class="fileinput-new"><i class="fa fa-camera"></i> Chose Image</span>
                                                <span class="fileinput-exists" style="display:none">Change Image</span><input type="file" name="..." @change="onImageChange"/></span>
                                                </div> 
                                                <div class="invalid-feedback" v-if="errors.dimage">
                                                    {{errors.dimage[0]}}
                                                </div>

                                                <img :src="imagePreview" v-if="dform.dimage" width="200" >
                                                <div v-if="editMode & !imagePreview">
                                                    <img :src="dform.dimage" v-if="dform.dimage" width="200">
                                                </div>
                                            </div>
                                        </div>
                                    </div>                                  

                                    <div class="row">
                                        <div class="col-md-12">
                                            <label style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); width: 100%; text-align:left; margin-bottom: 20px; background-color: #313A46; padding: 5px 5px; color: #ffffff">Account Ledger Setup *</label>
                                        </div>

                                        <div class="form-group col-md-6">
                                            <label for="doctor_commission_account">Doctor Commission Account Ledger *</label>
                                            <input type="text" class="form-control border " @keypress="onkeyPress('doctor_commission_account')" v-model="dform.doctor_commission_account" id="doctor_commission_account" placeholder="Doctor Commission Account"> 
                                            <div class="invalid-feedback" v-if="errors.doctor_commission_account">
                                                {{errors.doctor_commission_account[0]}}
                                            </div>
                                        </div>
                                    </div>

                                </div> 
                            </div>
                        </div>
                        <div class="modal-footer"> 
                            <button type="button" class="btn btn-danger" @click="toggleDoctorModal()">
                                Close
                            </button> 
                            <button type="submit" class="btn btn-primary " :disabled="disabled">
                                <span v-show="isSubmit">
                                    <i class="fas fa-spinner fa-spin" ></i>
                                </span>{{btn}} 
                            </button> 
                        </div>
                    </form>
                </div>
            </Modal>

            <!-- <Modal @close="toggleModal()" :modalActive="modalActive">
                <div id="newBilling" class="modal-content scrollbar-width-thin">
                    <div class="modal-header"> 
                        <h3>New Billing</h3>
                        <button @click="toggleModal()" type="button" class="btn btn-sm btn-danger"> <i class="mdi mdi-close-outline"></i></button>
                    </div>
                </div>
            </Modal> -->
            

            <!-- preview and Print Modal   -->
            <Modal @close="invoicePreviewModal()" :modalActive="invoicePreviewModalActive">
                <div class="modal-content scrollbar-width-thin invoice-modal">
                    <div class="modal-header">
                    <h5>Invoice</h5>
                    <button @click="invoicePreviewModal()" type="button" class="btn btn-default">
                        X
                    </button>
                    </div>
                    <div class="modal-body inv-perview">
                        <div id="invoice-billing" class="invoice-billing">
                            <div id="top">
                                <div class="row">
                                    <h2 class="text-center" style="font-size: 18px">{{this.retailShopName}}</h2>
                                    <h5 class="text-center" style="font-size: 14px"> {{ this.retailSmallText }}</h5>
                                    <p class="text-center cmb-5">
                                        {{ this.retailShopAddress }}
                                        <span v-if="invHeadPhone"> <br> Mobile: {{ this.invHeadPhone }} </span>
                                    </p> 
                                    <p class="text-center" ><strong> INVOICE </strong></p> 
                                </div>
                            </div>
                            <!--End InvoiceTop-->
                            <div id="mid">
                                <div class="info">
                                    <table style="width: 100%;">
                                        <tr>
                                            <td>ID No</td>
                                            <td>:</td>
                                            <td>{{ form.bill_no }}</td>
                                            <td>
                                                <BarcodeGenerator
                                                    :value="form.bill_no"
                                                    :format="'CODE128'"
                                                    :lineColor="'black'"
                                                    :height="22"
                                                    :width="1"
                                                    :elementTag="'img'"
                                                    :textPosition="19"
                                                    :fontSize="15"
                                                    :displayValue="false"
                                                    v-if="renderBarcodeComponent"
                                                />
                                            </td>
                                            <td style="text-align: right;">Date: {{ form.bill_date }}</td>
                                        </tr>
                                        <tr>
                                            <td>Name</td>
                                            <td>:</td>
                                            <td id="pname">{{ form.patient_name }}</td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td>Age</td>
                                            <td>:</td>
                                            <td>{{ form.patient_age }}</td>
                                            <td style="text-align: right;"><span>Gender: {{ form.patient_gender }}</span></td>
                                            <td style="text-align: right;"><span>M: {{ form.patient_phone }}</span></td>
                                        </tr>
                                        <tr>
                                            <td>Refd By</td>
                                            <td>:</td>
                                            <td colspan="3">{{ form.reference_person_name }}</td>
                                        </tr>
                                    </table>
                                </div>
                            
                            </div>
                            <!--End Invoice Mid-->
                            <div id="bot">
                                <div class="items-info">
                                    <table style="width: 100% !important;">
                                        <thead>
                                            <tr>
                                                <td>SL</td>
                                                <td>Test/Service</td>
                                                <td>Qty</td>
                                                <td>Amount</td>
                                                <td>Disc%</td>
                                                <td style="text-align: right">Delivery Date/Time</td>
                                            </tr>
                                        </thead>

                                        <tbody v-if="form.ptest_items.length > 0">
                                            <tr v-for="(item, i) in form.ptest_items" :key="i">
                                                <td>{{ i+1 }}</td>
                                                <td>{{ item.name }}</td>
                                                <td> {{ item.qty }} </td>
                                                <td style="text-align: right"> {{ Number(item.price).toFixed(2) }} </td>
                                                <td style="text-align: right"> {{ item.discount }} </td>
                                                <td style="text-align: right"> {{ item.delivery_datetime }} </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <!--End Table-->
                                </div>

                                <!-- Payment Info and Others-->
                                <div class="corporate-payment-info">
                                    <div class="row">
                                        <div class="col-md-7 col-xs-7">
                                            <div class="row">
                                                <div class="col-md-6 col-xs-6">
                                                    <div class="corporate-info" v-if="form.corporate_company_name">
                                                        <p style="margin: 0;">CORPORATE:</p>
                                                        <p>
                                                            {{ form.corporate_company_name }}
                                                            {{ 'ID-' + form.corporate_employee_id }}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 col-xs-6"></div>
                                            </div>
                                        </div>
                                        <div class="col-md-5 col-xs-5">
                                            <table class="payment-info" style="width: 100%; text-align: right;">
                                                <tr style="border-top: 1px solid #282828;">
                                                    <td>Total Amount</td>
                                                    <td>{{ totalCartValue }}</td>
                                                </tr>
                                                <tr>
                                                    <td>Discount ({{ (totalDiscountPercent - totalExtraDiscountPercent) }}%)</td>
                                                    <td>{{ totalGeneralDiscount }}</td>
                                                </tr>
                                                <tr style="border-top: 1px solid #282828;">
                                                    <td>Extra Discount </td>
                                                    <td>{{ totalExtraDiscount + totalFlatDiscount }}</td>
                                                </tr>
                                                <tr style="border-top: 1px solid #282828;">
                                                    <td>Payable </td>
                                                    <td>{{ Number(netAmountCalculate).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }}</td>
                                                </tr>                                                       
                                                <tr>
                                                    <td>Received Amount </td>
                                                    <td>{{ form.received_amount }}</td>
                                                </tr>                                                
                                                <tr style="border-top: 1px solid #282828;">
                                                    <td>Due Amount </td>
                                                    <td>{{ netAmountCalculate - form.received_amount }}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>                                            
                                </div>

                                <div class="fixed-div">
                                    <div class="status-signatures">
                                        <div class="row">
                                            <div class="col-md-8 col-xs-8">
                                                <div class="status-info">
                                                    <h3 v-if="(netAmountCalculate) == form.received_amount">
                                                        <span style="">PAID</span>
                                                    </h3> 
                                                    <h3 v-else>
                                                        <span>DUE</span>
                                                    </h3> 
                                                    <span style="font-size: 11px;">Printed on {{ new Date().toLocaleDateString() }} {{ new Date().toLocaleTimeString() }}</span>
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-xs-4">
                                                <div class="signature-info">
                                                    <h4>Amir</h4>
                                                    <span>(Signature)</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="room-info">
                                        <p> 
                                            যে সকল রুমে যাবেন: 
                                            <span v-for="(item, r) in form.room_numbers" :key="r">{{  item }}</span>
                                        </p>
                                    </div>
                                    
                                    <div class="legal-info">
                                        <h6>
                                            সকল তথ্য ও সিরিয়াল এর জন্য হটলাইনঃ {{ this.invHeadPhone }}
                                        </h6>
                                        <h6>
                                            বিঃদ্রঃ মূল রিসিট ছাড়া কোন রিপোর্ট ডেলিভারি হয় না ।
                                        </h6>
                                        <h6>
                                            রিপোর্ট ডেলিভারী নিচ তলায় রিসিপশন সকাল ৯টা - রাত ৯টা।
                                        </h6>
                                    </div>
                                </div>

                            </div>
                            <!--End InvoiceBot-->
                        </div>
                        <!--End Invoice-->
                    </div>
                    <div class="modal-footer">
                        <div class="col-md-12">
                            <div class="row button-list pt-2">
                            <div class="col-md-4" style="padding: 0 5px">
                                <div class="d-grid">
                                <button
                                    type="button"
                                    class="btn btn-sm btn-success"
                                    @click="printInvoice('invoice-billing')"
                                >
                                    Print
                                </button>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal> 
            <!-- Invoice Preview Modal End -->

            <!-- Invoice Print Modal After Save -->
            <Modal @close="invoiceModal()" :modalActive="invoiceModalActive">
                <div class="modal-content scrollbar-width-thin invoice-modal">
                    <div class="modal-header">
                    <h5>Invoice</h5>
                    <button @click="invoiceModal()" type="button" class="btn btn-default">
                        X
                    </button>
                    </div>
                    <div class="modal-body inv-perview">
                        <div id="billing-invoice" class="invoice-billing" v-if="billing_info != ''">
                            <div id="top">
                                <div class="row">
                                    <h2 class="text-center" style="font-size: 18px">{{this.retailShopName}}</h2>
                                    <h5 class="text-center" style="font-size: 14px"> {{ this.retailSmallText }}</h5>
                                    <p class="text-center cmb-5">
                                        {{ this.retailShopAddress }}
                                        <span v-if="invHeadPhone"> <br> Mobile: {{ this.invHeadPhone }} </span>
                                    </p> 
                                    <p class="text-center" ><strong> INVOICE </strong></p> 
                                </div>
                            </div>
                            <!--End InvoiceTop-->
                            <div id="mid">
                                <div class="info">
                                    <table style="width: 100%;">
                                        <tr>
                                            <td>ID No</td>
                                            <td>:</td>
                                            <td>{{ billing_info.bill_no }}</td>
                                            <td>
                                                <BarcodeGenerator
                                                    :value="billing_info.bill_no"
                                                    :format="'CODE128'"
                                                    :lineColor="'black'"
                                                    :height="22"
                                                    :width="1"
                                                    :elementTag="'img'"
                                                    :textPosition="19"
                                                    :fontSize="15"
                                                    :displayValue="false"
                                                    v-if="renderBarcodeComponent"
                                                />
                                            </td>
                                            <td style="text-align: right;">Date: {{ billing_info.bill_date }}</td>
                                        </tr>
                                        <tr>
                                            <td>Name</td>
                                            <td>:</td>
                                            <td id="pname">{{ billing_info.patient_name }}</td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td>Age</td>
                                            <td>:</td>
                                            <td>{{ billing_info.patient_age }}</td>
                                            <td style="text-align: right;"><span>Gender: {{ billing_info.patient_gender }}</span></td>
                                            <td style="text-align: right;"><span>M: {{ billing_info.patient_phone }}</span></td>
                                        </tr>
                                        <tr>
                                            <td>Refd By</td>
                                            <td>:</td>
                                            <td colspan="3">{{ billing_info.reference_person_name }}</td>
                                        </tr>
                                    </table>
                                </div>
                            
                            </div>
                            <!--End Invoice Mid-->
                            <div id="bot">
                                <div class="items-info">
                                    <table style="width: 100% !important;">
                                        <thead>
                                            <tr>
                                                <td>SL</td>
                                                <td>Test/Service</td>
                                                <td>Qty</td>
                                                <td>Amount</td>
                                                <td>Disc%</td>
                                                <td style="text-align: right">Delivery Date/Time</td>
                                            </tr>
                                        </thead>

                                        <tbody v-if="billing_info.test_items.length > 0">
                                            <tr v-for="(item, i) in billing_info.test_items" :key="i">
                                                <td>{{ i+1 }}</td>
                                                <td>{{ item.diagnosis_tests.name }}</td>
                                                <td> {{ item.quantity }} </td>
                                                <td style="text-align: right"> {{ Number(item.price).toFixed(2) }} </td>
                                                <td style="text-align: right"> {{ item.discount }} </td>
                                                <td style="text-align: right"> {{ item.delivery_datetime }} </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <!--End Table-->
                                </div>

                                <!-- Payment Info and Others-->
                                <div class="corporate-payment-info">
                                    <div class="row">
                                        <div class="col-md-7 col-xs-7">
                                            <div class="row">
                                                <div class="col-md-6 col-xs-6">
                                                    <div class="corporate-info" v-if="billing_info.corporate_discount_status == 1">
                                                        <p style="margin: 0;">CORPORATE: </p>
                                                        <p>
                                                            {{ billing_info.corporate_company_name }} <br>
                                                            {{ 'Employee ID - ' + billing_info.corporate_employee_id }}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 col-xs-6"></div>
                                            </div>
                                        </div>
                                        <div class="col-md-5 col-xs-5">
                                            <table class="payment-info" style="width: 100%; text-align: right;">
                                                <tr style="border-top: 1px solid #282828;">
                                                    <td>Total Amount</td>
                                                    <td>{{ Number(billing_info.total_amount).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }}</td>
                                                </tr>
                                                <tr>
                                                    <td>Discount ({{ (billing_info.discount_percent - billing_info.extra_discount_percent) }}%)</td>
                                                    <td>
                                                        {{ Number(billing_info.general_discount).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}}
                                                    </td>
                                                </tr>
                                                <tr style="border-top: 1px solid #282828;">
                                                    <td>Extra Discount ({{  billing_info.extra_discount_percent - 0 }}%)</td>
                                                    <td>
                                                        {{ Number(billing_info.extra_discount).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }}
                                                    </td>
                                                </tr>
                                                <tr style="border-top: 1px solid #282828;">
                                                    <td>Payable </td>
                                                    <td>{{ Number(billing_info.payable_amount).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }}</td>
                                                </tr>                                                       
                                                <tr>
                                                    <td>Received Amount </td>
                                                    <td>
                                                        {{ Number(billing_info.paid_amount).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }}
                                                    </td>
                                                </tr>                                                
                                                <tr style="border-top: 1px solid #282828;">
                                                    <td>Due Amount </td>
                                                    <td>
                                                        {{ Number(billing_info.payable_amount - billing_info.paid_amount).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }}
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>                                            
                                </div>

                                <div class="fixed-div">
                                    <div class="status-signatures">
                                        <div class="row">
                                            <div class="col-md-8 col-xs-8">
                                                <div class="status-info">
                                                    <h3 v-if="(billing_info.payable_amount) == billing_info.paid_amount">
                                                        <span style="">PAID</span>
                                                    </h3> 
                                                    <h3 v-else>
                                                        <span>DUE</span>
                                                    </h3> 
                                                    <span style="font-size: 11px;">Printed on {{ new Date().toLocaleDateString() }} {{ new Date().toLocaleTimeString() }}</span>
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-xs-4">
                                                <div class="signature-info">
                                                    <h4>{{ billing_info.created_users.name }}</h4>
                                                    <span>(Signature)</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="room-info">
                                        <p> 
                                            যে সকল রুমে যাবেন: 
                                            <span v-for="(item, r) in JSON.parse(billing_info.room_numbers)" :key="r">{{  item }}</span>
                                        </p>
                                    </div>
                                    
                                    <div class="legal-info">
                                        <h6>
                                            সকল তথ্য ও সিরিয়াল এর জন্য হটলাইনঃ {{ this.invHeadPhone }}
                                        </h6>
                                        <h6>
                                            বিঃদ্রঃ মূল রিসিট ছাড়া কোন রিপোর্ট ডেলিভারি হয় না ।
                                        </h6>
                                        <h6>
                                            রিপোর্ট ডেলিভারী নিচ তলায় রিসিপশন সকাল ৯টা - রাত ৯টা।
                                        </h6>
                                    </div>
                                </div>

                            </div>
                            <!--End InvoiceBot-->
                        </div>
                        <!--End Invoice-->
                    </div>
                    <div class="modal-footer">
                        <div class="col-md-12">
                            <div class="row button-list pt-2">
                            <div class="col-md-4" style="padding: 0 5px">
                                <div class="d-grid">
                                <button
                                    type="button"
                                    class="btn btn-sm btn-success"
                                    @click="printInvoice('billing-invoice')"
                                >
                                    Print
                                </button>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal> 


        </div>
    </transition>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Modal from "../../helper/Modal";
import BarcodeGenerator from "@/components/BarcodeGenerator.vue";
import Datatable from '@/components/Datatable.vue';
import Pagination from '@/components/Pagination.vue';
import { ref, onMounted } from "vue";
import Form from 'vform'
import axios from 'axios';
export default {
    name: 'Appointments',
    components: {
        Modal,
        BarcodeGenerator,
        Datatable,
        Pagination,
    },
    props:{
        language: {
          type: Object,
          default: () => {
            return {
              lengthMenu: null,
              info: null,
              zeroRecords: null, 
              search: null
            }
          },
        },
    },
    data() {
        return {
            loading: true,
            isSubmit: false,
            showModal: false,
            editMode:false,
            disabled: false,
            modalActive:false,
            doctorAddModalActive:false,
            invoiceModalActive:false,            
            invoicePreviewModalActive:false,            
            errors: {},
            imagePreview: '',
            btn:'SUBMIT',
            renderOptionComponent: true,
            renderBarcodeComponent: true,
            companies: [],
            departments: [],
            costCenterOptions: [],
            valueConsistsOf: 'BRANCH_PRIORITY',
            normalizer(node) {
                return {
                    id: node.id+'___'+node.code,
                    label: node.name,
                    children: node.children,
                }
            },
            items: [],
            gender_options: [{label:'Male', value:'male'}, {label:'Female', value:'female'}],
            doctors: [],
            doctor_options: [],
            test_items: [],
            discount_items: [],
            test_name: '',
            searchTerm: '',
            arrowCounter: -1,
            searchTests: [],     
            billing_info: '',  
            patients: [],
            patient_options: [],    
            search_patient_id: null,
            form: new Form({
                id: '',
                bill_no: '',
                bill_date: '',
                patient_name: '',
                patient_age: '',
                patient_gender: '',
                patient_phone: '',
                reference_type: 'doctor',
                reference_person_id: '',
                reference_person_name: '',
                delivery_date: '',
                delivery_time: '05:00 PM',
                ptest_items: [], 
                ptest_reagent_items: [],
                ptest_stequipment_items: [],
                ptest_discount_items: [],
                room_numbers: [],
                corporate_company_name: '',
                corporate_employee_id: '',
                corporate_employee_name: '',
                vat_tax: 0,
                received_amount: 0,
                status: 1,
                cost_center_id: null,

            }),
            age: {
                years: '',
                months: '',
                days: '',
            },
            dform: new Form({
                id: '',
                doctor_code: '', 
                company_id: 0, 
                department_id: "", 
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                designation: '',
                qualification: '',
                specialist: '',
                dob: '',
                blood_group: '',
                gender: 'male',
                status: 1,
                create_user: 0,
                password: '',
                password_confirmation: '',
                commission_percentage: '',
                description: '',
                dimage: '',
                doctor_commission_account: '',
            }),
            multiclasses: { 
                clear: '',
                clearIcon: '', 
            },

        };
    },

    created() { 
        this.fetchDiagnosisBIllingCreateData();
        this.fetchCompany();
        this.fetchDepartments();
        this.fetchCostCenters();
    },

    methods: { 
        forceRerender() {
            // Remove my-component from the DOM
            this.renderOptionComponent = false;
            this.renderBarcodeComponent = false;

            this.$nextTick(() => {
                // Add the component back in
                this.renderOptionComponent = true;
                this.renderBarcodeComponent = true;

            });
        },
        toggleModal: function() {
            this.modalActive = !this.modalActive;   
            if(!this.modalActive){
                this.editMode = false;
                this.btn='Create';
            } 
            this.errors = '';
            this.isSubmit = false;
        },

        // For Doctor Add Modal
            toggleDoctorModal: function() {
                this.doctorAddModalActive = !this.doctorAddModalActive;   
                if(!this.doctorAddModalActive){
                    this.editMode = false;
                    this.btn='Create';
                } 
                this.errors = '';
                this.isSubmit = false;
            },

            doctorAddModal: function() {  
                this.forceRerender();
                this.doctorAddModalActive = !this.doctorAddModalActive;
            },
            

            // Ledger Account Name Setup
            ledgerAccountNameSetup: function(value) {
                if(value != '') {
                    this.dform.doctor_commission_account = 'Provision for '+value;
                }else{
                    this.dform.doctor_commission_account = '';
                }
            },

            submitDoctorForm: function(e) {  
                this.isSubmit = true;
                this.disabled = true;
                const formData = new FormData();              
                // formData.append('doctor_code', this.dform.doctor_code);
                formData.append('company_id', this.dform.company_id);
                formData.append('department_id', this.dform.department_id);
                formData.append('first_name', this.dform.first_name);
                formData.append('last_name', this.dform.last_name);
                formData.append('email', this.dform.email);
                formData.append('phone', this.dform.phone);
                formData.append('designation', this.dform.designation);
                formData.append('qualification', this.dform.qualification);
                formData.append('specialist', this.dform.specialist);
                formData.append('dob', this.dform.dob);
                formData.append('blood_group', this.dform.blood_group);
                formData.append('gender', this.dform.gender);
                formData.append('status', this.dform.status);
                formData.append('create_user', this.dform.create_user);
                formData.append('password', this.dform.password);
                formData.append('password_confirmation', this.dform.password_confirmation);
                formData.append('commission_percentage', this.dform.commission_percentage);
                formData.append('description', this.dform.description);
                formData.append('doctor_commission_account', this.dform.doctor_commission_account);

                this.dform.dimage ? formData.append('dimage', this.dform.dimage, this.dform.dimage.name) : '';
                var postEvent = axios.post(this.apiUrl+'/hm/doctors', formData, this.headers);          

                postEvent.then(res => {
                    this.isSubmit = false;
                    this.disabled = false;
                    if(res.status == 200){
                        this.toggleDoctorModal();
                        this.dform.reset();
                        this.doctor_options.push({label:res.data.data.first_name + ' ' + res.data.data.last_name, value:res.data.data.id});
                        this.form.reference_person_id = res.data.data.id;
                        this.form.reference_person_name = res.data.data.first_name + ' ' + res.data.data.last_name;
                        
                        this.$toast.success(res.data.message); 
                    }else{
                        this.$toast.error(res.data.message);
                    } 
                }).catch(err => { 
                    this.isSubmit = false; 
                    this.disabled = false;
                    this.$toast.error(err.response.data.message);
                    if(err.response.status == 422){
                        this.errors = err.response.data.errors 
                    } 
                });
            }, 

            onImageChange(e) {
                this.form.dimage = e.target.files[0]
                let files = e.target.files || e.dataTransfer.files;
                if (!files.length)
                    return;  
                
                this.createImage(files[0]);

            },

            createImage(file) {
                let reader = new FileReader();
                let vm = this;
                reader.onload = (e) => { 
                    vm.imagePreview = e.target.result;
                };
                reader.readAsDataURL(file);
            },
        // End Doctor Add Modal
         
        invoiceModal: function() {  
            this.forceRerender();
            this.invoiceModalActive = !this.invoiceModalActive;
        },

        invoicePreviewModal: function() {
            this.forceRerender();
            this.invoicePreviewModalActive = !this.invoicePreviewModalActive;
        },

        printContent(document_id) { 
            const options = {
                name: '_blank',
                specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
                styles: [ 
                    this.baseUrlPrintCSS+'/assets/css/bootstrap-print.min.css',
                    this.baseUrlPrintCSS+'/assets/css/billing_invoice.css'
                ],
            };
            this.$htmlToPaper(document_id, options);
        },


        fetchCompany() { 
            axios.get(this.apiUrl+'/companies', this.headerjson)
            .then((res) => {
                this.companies = res.data.data; 
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            }); 
        }, 
        
        fetchDepartments() { 
            axios.get(this.apiUrl+'/hm/departments', this.headerjson)
            .then((res) => {
                // this.departments = res.data.data; 
                this.departments = [{label: "Select Department", value: ""}];
                res.data.data.map((item) => {
                    this.departments.push({label:item.name, value:item.id});
                });
            }) 
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            })
        }, 

        fetchCostCenters()
        {
            axios.get(this.apiUrl+'/cost_centers', this.headerjson)
            .then((res) => {
                this.costCenterOptions = res.data.data.cost_center_options;
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            });
        },

        fetchDiagnosisBIllingCreateData() {
            axios.get(this.apiUrl+'/hm/diagnosis_billings/create', this.headerjson)
            .then((res) => {
                let data = res.data.data;
                this.form.bill_no = data.bill_no;
                this.invoice_no = data.bill_no;
                this.form.bill_date = data.bill_date;
                this.test_items = data.diagnosis_tests;
                this.doctors = data.doctors;
                this.doctor_options = data.doctors.map((item) => {
                    return {label:item.first_name + ' ' + item.last_name, value:item.id}
                });
                this.discount_items = data.discount_items;
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            }).finally((ress) => {
                this.loading = false;
            });
        },

        getPatientByPhone(event) {
            let phone = event.target.value;
            if ((typeof event !== 'undefined' && (event.keyCode === 13) ) || false) {
                this.search_patient_id = null;
                this.form.patient_name = '';
                this.form.patient_age = '';
                this.form.patient_gender = '';
                this.patients = [];
                this.patient_options = [];
            }
            
            if (phone.length < 11 && 
                (
                    (typeof event !== 'undefined' && (event.keyCode === 13) ) ||
                    // fallback: if event is not available, still allow for legacy behavior
                    false
                )
            ) {
                this.$toast.error('Please enter valid phone number!');
                return;
            }
            // Only proceed if phone is 11 digits and last key pressed was 'g' or 'G'
            if (phone.length === 11 &&
                (
                    (typeof event !== 'undefined' && (event.keyCode === 13) ) ||
                    // fallback: if event is not available, still allow for legacy behavior
                    false
                )
            ) {
                axios.get(this.apiUrl+'/hm/diagnosis_billings/get-patient-by-phone?phone='+phone, this.headerjson)
                .then((res) => {
                    this.search_patient_id = null;
                    this.form.patient_name = '';
                    this.form.patient_age = '';
                    this.form.patient_gender = '';
                    this.patients = [];
                    this.patient_options = [];
                    let data = res.data.data;
                    if(data.length == 1) {
                        this.form.patient_name = data[0].name;
                        this.form.patient_age = data[0].age;
                        this.form.patient_gender = data[0].gender;
                        if(this.form.patient_age) {
                            this.parseAge(this.form.patient_age);
                        }
                    }else {
                        this.patients = data;
                        this.patient_options = data.map((item) => {
                            return {label:item.name, value:item.id}
                        });

                        setTimeout(() => {
                            // wait for DOM update AFTER options assigned
                            this.$nextTick(() => {
                                if (this.$refs.patientMultiselect) {
                                    this.$refs.patientMultiselect.activate(); // open & focus
                                }else {
                                    console.warn('patient multiselect ref not ready yet');
                                }
                            });
                        }, 1000);

                    }
                })
                .catch((err) => { 
                    this.$toast.error(err.response.data.message);
                });
            }
        },

        changePatient(selectedValue) {
            const selectedOption = this.patient_options.find(option => option.value === selectedValue);
            if (selectedOption) {
                const patient = this.patients.find(p => p.id === selectedValue);
                if (patient) {
                    this.form.patient_name = patient.name;
                    this.form.patient_age = patient.age;
                    this.form.patient_gender = patient.gender;
                    if(this.form.patient_age) {
                        this.parseAge(this.form.patient_age);
                    }
                }
            }else{
                this.form.patient_name = '';
                this.form.patient_age = '';
                this.form.patient_gender = '';
            }
        },

        parseAge(ageString) {
            const match = ageString.match(/(\d+)y\s*(\d+)m\s*(\d+)d/)
            if (match) {
                this.age.years  = Number(match[1])
                this.age.months = Number(match[2])
                this.age.days   = Number(match[3])
            }else{
                if(ageString) {
                    this.age.years = ageString;
                    this.updateAge();
                }
            }
        },

        validateAge(field) {
            if(field === 'years' && this.age.years < 0) {
                this.age.years = 0;
            }
            if(field === 'months') {
                if(this.age.months < 0) {
                    this.age.months = 0;
                } else if(this.age.months > 11) {
                    this.age.months = 11;
                }
            }
            if(field === 'days') {
                if(this.age.days < 0) {
                    this.age.days = 0;
                } else if(this.age.days > 29) {
                    this.age.days = 29;
                }
            }
        },

        updateAge() {
            let y = this.age.years || 0
            let m = this.age.months || 0
            let d = this.age.days || 0

            this.form.patient_age = `${y}y ${m}m ${d}d`
        },

        changeReferencePerson(selectedValue) {
            const selectedOption = this.doctor_options.find(option => option.value === selectedValue);
            const selectedText = selectedOption ? selectedOption.label : null;

            if (selectedText) {
                this.form.reference_person_name = selectedText;
            } else {
                this.form.reference_person_name = selectedValue;
            }
        },

        /** Diagnosis Test Search Data */
        getTestByName() {
            if(this.test_name == '') {
                this.test_name = this.searchTerm;
            }
            this.searchTerm = '';
            if(!this.checkExistsTest(this.form.ptest_items, this.test_name)) {
                if(this.test_name != '') {
                    var cart_item = this.test_items.find(item => item.name == this.test_name);
                    cart_item.qty = 1;
                    if(this.form.delivery_date != '') {
                        cart_item.delivery_datetime = this.form.delivery_date + ' 05:00 PM';
                    }

                    if(cart_item) {
                        this.test_name = '';
                        this.searchTerm = '';
                        this.arrowCounter = -1;
                        this.form.ptest_items.push(cart_item);

                        // For Reagent
                        var ptest_reagent_items = cart_item.dtconfig_reagents.map((item) => {
                            return {
                                id: item.reagent_id,
                                name: item.reagents.product_name,
                                category_id: item.reagents.category_id,
                                qty: item.qty,
                                price: item.price,
                                test_ids: [item.test_id]
                            }
                        });

                        ptest_reagent_items.forEach((newItem) => {
                            // Find if item already exists in ptest_reagent_items based on the id
                            const existingItem = this.form.ptest_reagent_items.find((item) => item.id === newItem.id);
                            
                            if (existingItem) {
                                // If item exists, increase the qty
                                existingItem.qty += newItem.qty;

                                // Add the test_id to test_ids array if it doesn't already exist
                                if (!existingItem.test_ids.includes(newItem.test_ids[0])) {
                                    existingItem.test_ids.push(newItem.test_ids[0]);
                                }

                            } else {
                                // If item does not exist, push the new item
                                this.form.ptest_reagent_items.push(newItem);
                            }
                        });

                        // For Stationery Items
                        var ptest_stationery_items = cart_item.dtconfig_stequipments.map((item) => {
                            return {
                                id: item.product_id,
                                name: item.products.product_name,
                                category_id: item.products.category_id,
                                qty: item.qty,
                                price: item.price,
                                test_ids: [item.test_id]
                            }
                        });

                        ptest_stationery_items.forEach((newItem) => {
                            // Find if item already exists in ptest_stationery_items based on the id
                            const existingItem = this.form.ptest_stequipment_items.find((item) => item.id === newItem.id);
                            
                            if (existingItem) {
                                // If item exists, increase the qty
                                if(existingItem.name.toLowerCase() != 'memo') {
                                    existingItem.qty += newItem.qty;
                                }

                                // Add the test_id to test_ids array if it doesn't already exist
                                if (!existingItem.test_ids.includes(newItem.test_ids[0])) {
                                    existingItem.test_ids.push(newItem.test_ids[0]);
                                }

                            } else {
                                // If item does not exist, push the new item
                                this.form.ptest_stequipment_items.push(newItem);
                            }
                        });

                        // For Room Numbers 
                        const existingRoom = this.form.room_numbers.indexOf(cart_item.allocated_room);
                        if (existingRoom == -1) {
                            this.form.room_numbers.push(cart_item.allocated_room);
                        }
                        
                    }

                }
            }else{
                this.test_name = '';
                this.searchTerm = '';
                this.arrowCounter = -1;
                this.$toast.error("This Test Already Added!");
            }

        },

        inputChanged(event) {

            if (event.code == "ArrowUp" || event.code == "ArrowDown")
                return;
                
            this.searchTests = [];

            if (event.code == "Enter")
                return;
            if(this.searchTerm == '') 
                return;


            var filtered = this.test_items.filter(item => {
                let item_data = '';
                item_data = item.name;
                return item_data.toLowerCase().match(this.searchTerm.toLowerCase());

            });

            // this.isOpen = true
            this.searchTests.push(...filtered);
            if(this.arrowCounter == -1) {
                return;
            }
            let match_data = this.searchTests[this.arrowCounter].name;
            if(match_data != this.searchTerm) {
                this.arrowCounter = -1;
            }

        },

        selectTests(item) { 
            this.test_name = item.name;
            this.searchTerm = item.name;
        }, 

        setResult(item) { 
            this.test_name = item.name;
            this.searchTerm = item.name;
            this.getTestByName();
            this.searchTests = [];
        }, 

            // For Check Product List
        checkExistsTest(array_data, test_name){
            let testExists = false;
            array_data.map((item) => {
                if(item.name == test_name) {
                    testExists = true;
                }
            });

            return testExists;
        },

        removeTestListItem(row_id) {
            if (this.form.ptest_items[row_id]) {
                // Get the test item ID that will be removed
                const testItemId = this.form.ptest_items[row_id].id;
                
                // For Reagent Items
                var relatedReagents = this.form.ptest_reagent_items.filter(item => item.test_ids.includes(testItemId));
                relatedReagents.forEach((reagentItem) => {
                    // Calculate the quantity to decrease based on the specific test item's reagent quantity
                    let testItemReagentQty = this.form.ptest_items[row_id].dtconfig_reagents.find(r => r.reagent_id === reagentItem.id)?.qty || 0;

                    if (testItemReagentQty > 0) {
                        // Decrease the qty of the reagent item
                        reagentItem.qty -= testItemReagentQty;
                        reagentItem.test_ids.splice(reagentItem.test_ids.indexOf(testItemId), 1);
                    }

                    // Check if any other test items use this reagent
                    const isReagentUsedByOthers = this.form.ptest_items.some(item => 
                        item.id !== testItemId && 
                        item.dtconfig_reagents.some(r => r.reagent_id === reagentItem.id)
                    );

                    // If no other test items use this reagent and the qty is zero or less, remove it
                    // if (!isReagentUsedByOthers && reagentItem.qty <= 0) {
                    if (!isReagentUsedByOthers) {
                        this.form.ptest_reagent_items.splice(this.form.ptest_reagent_items.indexOf(reagentItem), 1);
                    }
                });

                // For Staionery Items
                var releatedStationery = this.form.ptest_stequipment_items.filter(item => item.test_ids.includes(testItemId));
                releatedStationery.forEach((stationeryItem) => {
                    // Calculate the quantity to decrease based on the specific test item's reagent quantity
                    let testItemStationeryQty = this.form.ptest_items[row_id].dtconfig_stequipments.find(r => r.product_id === stationeryItem.id)?.qty || 0;

                    if (testItemStationeryQty > 0 && stationeryItem.name.toLowerCase() != 'memo') {
                        // Decrease the qty of the reagent item
                        stationeryItem.qty -= testItemStationeryQty;
                        stationeryItem.test_ids.splice(stationeryItem.test_ids.indexOf(testItemId), 1);
                    }

                    // Check if any other test items use this reagent
                    const isStationeryUsedByOthers = this.form.ptest_items.some(item => 
                        item.id !== testItemId && 
                        item.dtconfig_stequipments.some(r => r.product_id === stationeryItem.id)
                    );

                    // If no other test items use this reagent and the qty is zero or less, remove it
                    // if (!isReagentUsedByOthers && reagentItem.qty <= 0) {
                    if (!isStationeryUsedByOthers) {
                        this.form.ptest_stequipment_items.splice(this.form.ptest_stequipment_items.indexOf(stationeryItem), 1);
                    }
                });

                // For Room Numbers 
                const testItemRoom = this.form.ptest_items[row_id].allocated_room;
                const isRoomUsedByOthers = this.form.ptest_items.some(item => 
                    item.id !== testItemId && item.allocated_room === testItemRoom
                );

                // If no other test items use this room, remove it from room_numbers
                if (!isRoomUsedByOthers) {
                    const roomIndex = this.form.room_numbers.indexOf(testItemRoom);
                    if (roomIndex !== -1) {
                        this.form.room_numbers.splice(roomIndex, 1);
                    }
                }

                // Finally, remove the test item from ptest_items
                this.form.ptest_items.splice(row_id, 1);
            } else {
                this.$toast.error("Oop's, something went wrong please try again!");
            }
        },

        onArrowDown: function(event) {
            if (this.searchTests.length > 0) {
                this.arrowCounter = event.code == "ArrowDown" ? ++this.arrowCounter : --this.arrowCounter;
                if (this.arrowCounter >= this.searchTests.length)
                this.arrowCounter = (this.arrowCounter) % this.searchTests.length;
                else if (this.arrowCounter < 0)
                this.arrowCounter = this.searchTests.length + this.arrowCounter;
                this.selectTests(this.searchTests[this.arrowCounter]);
            }
        },

        onArrowUp: function(event) {
            if (this.searchTests.length > 0) {
                this.arrowCounter = event.code == "ArrowUp" ? --this.arrowCounter : ++this.arrowCounter;
                if (this.arrowCounter >= this.searchTests.length)
                this.arrowCounter = (this.arrowCounter) % this.searchTests.length;
                else if (this.arrowCounter < 0)
                this.arrowCounter = this.searchTests.length + this.arrowCounter;
                this.selectTests(this.searchTests[this.arrowCounter]);
            }
        },

        changeDeliveryDateTime() {
            if(this.form.delivery_date != '' && this.form.ptest_items.length > 0) {
                this.form.ptest_items.forEach((pitem) => {
                    return pitem.delivery_datetime = this.form.delivery_date + ' 05:00 PM';
                });
            }
        },

        applyDiscount: function(index,item) {
            if(this.discount_items[index].is_checked == false){
                this.discount_items[index].is_checked = true;
            }else{
                this.discount_items[index].is_checked = false;
            }
            if(item.is_checked) {
                if(item.discount_percent > 0) {
                    this.form.ptest_items.forEach((pitem) => {
                        let item_discount_percent = 0;

                        let item_discount = parseFloat(pitem.discount) + parseFloat(item.discount_percent);
                        if(item_discount > parseFloat(this.totalDiscountPercent)) {
                            item_discount_percent = this.totalDiscountPercent;
                        }else{
                            item_discount_percent = item_discount;
                        }
                        return pitem.discount = item_discount_percent;
                    });
                }
            }else{
                
                if(item.discount_percent > 0) {
                    this.form.ptest_items.forEach((pitem) => {
                        let item_discount_percent = 0;
                        let item_discount = (parseFloat(pitem.discount) > parseFloat(item.discount_percent)) ? parseFloat(pitem.discount) - parseFloat(item.discount_percent) : parseFloat(pitem.discount);
                        if(item_discount > this.totalDiscountPercent) {
                            item_discount_percent = this.totalDiscountPercent;
                        }else{
                            item_discount_percent = item_discount;
                        }
                        return pitem.discount = item_discount_percent;
                    });
                }
            }
        },

        changeApplyDiscount: function(index,item) {
            if(item.is_checked) {
                this.form.ptest_items.forEach((pitem) => {
                    let item_discount_percent = 0;
                    // safely handle null/undefined/empty string
                    let baseDiscount = 0;
                    let newDiscount  = parseFloat(item.discount_percent) || 0;

                    let item_discount = baseDiscount + newDiscount;

                    if (item_discount > parseFloat(this.totalDiscountPercent)) {
                        item_discount_percent = this.totalDiscountPercent;
                    } else {
                        item_discount_percent = item_discount;
                    }

                    return pitem.discount = item_discount_percent;
                });
            }else{
                this.form.ptest_items.forEach((pitem) => {
                    let item_discount_percent = 0;
                    let item_discount = (parseFloat(pitem.discount) > parseFloat(item.discount_percent)) ? parseFloat(pitem.discount) - parseFloat(item.discount_percent) : parseFloat(pitem.discount);
                    if(item_discount > this.totalDiscountPercent) {
                        item_discount_percent = this.totalDiscountPercent;
                    }else{
                        item_discount_percent = item_discount;
                    }
                    return pitem.discount = item_discount_percent;
                });
            }
        },

        show: function(item) {     
            axios.get(this.apiUrl+'/hm/diagnosis_billings/'+item.id, this.headers).then(res => {
                if(res.status == 200){  
                    this.customer = res.data.data
                    this.showModal = !this.showModal;  
                }else{
                    this.$toast.error(res.data.message);
                }
            }).catch(err => {  
                this.$toast.error(err.response.data.message);
                if(err.response.status == 422){
                    this.errors = err.response.data.errors 
                }
            }) 
        },

        edit: function(item) { 
            this.btn='Update';
            this.editMode = true;
            this.toggleModal();
            let department_doctors = this.doctors.filter((doctor, index) => {
                    return doctor.department_id == item.department_id;
            });

            if(department_doctors.length > 0) {
                this.doctor_options = department_doctors.map((item) => { 
                    return {label:item.name, value:item.id};
                });
            }

            this.form.fill(item);  
        },

        submitForm: function(e) {  
            this.isSubmit = true;
            this.disabled = true;
            const formData = new FormData();    
            formData.append('bill_no', this.form.bill_no);
            formData.append('bill_date', this.form.bill_date);
            formData.append('patient_name', this.form.patient_name);
            formData.append('patient_age', this.form.patient_age);
            formData.append('patient_gender', this.form.patient_gender);
            formData.append('patient_phone', this.form.patient_phone);
            formData.append('reference_type', this.form.reference_type);
            formData.append('reference_person_id', this.form.reference_person_id);
            formData.append('reference_person_name', this.form.reference_person_name);
            formData.append('delivery_date', this.form.delivery_date);
            formData.append('delivery_datetime', this.form.delivery_date+ ' ' + this.form.delivery_time);
            formData.append('ptest_items', JSON.stringify(this.form.ptest_items));  
            formData.append('ptest_reagent_items', JSON.stringify(this.form.ptest_reagent_items));
            formData.append('ptest_stequipment_items', JSON.stringify(this.form.ptest_stequipment_items));
            formData.append('discount_items', JSON.stringify(this.discount_items));
            formData.append('room_numbers', JSON.stringify(this.form.room_numbers)); 
            formData.append('corporate_company_name', this.form.corporate_company_name);
            formData.append('corporate_employee_id', this.form.corporate_employee_id);
            formData.append('corporate_employee_name', this.form.corporate_employee_name);
            formData.append('total_amount', this.totalCartValue);     
            formData.append('total_discount_percent', this.totalDiscountPercent);     
            formData.append('general_discount_percent', (this.totalDiscountPercent - this.totalExtraDiscountPercent));     
            formData.append('extra_discount_percent', this.totalExtraDiscountPercent);     
            formData.append('total_discount_amount', (this.totalGeneralDiscount + this.totalExtraDiscount + this.totalFlatDiscount));     
            formData.append('general_discount_amount', this.totalGeneralDiscount);     
            formData.append('extra_discount_amount', (this.totalExtraDiscount + this.totalFlatDiscount));     
            formData.append('payable_amount', this.netAmountCalculate);     
            formData.append('received_amount', this.form.received_amount);
            formData.append('status', this.form.status);
            formData.append('cost_center_id', this.form.cost_center_id);

            if(this.editMode) {
                formData.append('_method', 'put');           
                formData.append('id', this.form.id);
                var postEvent = axios.post(this.apiUrl+'/hm/diagnosis_billings/'+this.form.id, formData, this.headers);
            } else{  
                var postEvent = axios.post(this.apiUrl+'/hm/diagnosis_billings', formData, this.headers);
            }           

            postEvent.then(res => {
                this.isSubmit = false;
                this.disabled = false;
                if(res.status == 200){
                        this.billing_info = res.data.data;
                        this.form.reset();
                        this.search_patient_id = null;
                        this.patients = [];
                        this.patient_options = [];
                        this.forceRerender();
                        this.invoiceModal();
                        this.fetchDiagnosisBIllingCreateData();
                        this.$toast.success(res.data.message); 

                        setTimeout(() => {
                            this.printContent("billing-invoice");
                        }, 3000);
                }else{
                    this.$toast.error(res.data.message);
                } 
            }).catch(err => { 
                this.isSubmit = false; 
                this.disabled = false;
                this.$toast.error(err.response.data.message);
                if(err.response.status == 422){
                    this.errors = err.response.data.errors 
                } 
            });
        }, 

        validation: function (...fiels){ 
            var obj = new Object(); 
            var validate = false;
            for (var k in fiels){     // Loop through the object  
                for (var j in this.form){  
                    if((j==fiels[k]) && (!this.form[j])) {  
                        obj[fiels[k]] = fiels[k].replace("_", " ")+' field is required';  // Delete obj[key]; 
                        this.errors = {...this.errors, ...obj};
                    }else{
                        validate = false;
                    }
                }              
            }  
            // var obj = new Object();
            // obj[fiels] = fiels.replace("_", " ")+' field is required';  
            // this.errors = {...this.errors, ...obj}; 
        },
        onkeyPress: function(field) { 
            for (var k in this.errors){     // Loop through the object
                if(k==field){      // If the current key contains the string we're looking for 
                    delete this.errors[k];  // Delete obj[key];
                }
            }  
        },
        deleteItem: function(item) {
            this.$swal({
                title: 'Are you sure?',
                text: "You want delete this bill!", 
                showCancelButton: true,
                confirmButtonCategory: '#3085d6',
                cancelButtonCategory: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => { 
                if (result.value) { 
                    axios.delete(this.apiUrl+'/hm/diagnosis_billings/'+item.id,this.headerjson)
                    .then(res => {
                        if(res.status == 200){  
                            this.fetchDiagnosisBIllingCreateData();
                            this.$toast.success(res.data.message); 
                        }else{
                            this.$toast.error(res.data.message);
                        }
                    }).catch(err => {  
                        this.$toast.error(err.response.data.message); 
                    }) 
                }else{
                    // this.$toast.error(`Hey! I'm here`);
                    // this.$toast.warning(`Hey! I'm here`);
                    // this.$toast.info(`Hey! I'm here`)
                }
            }); 
        },

        printInvoice: function (print_id) {   
            this.printContent(print_id);
            // this.invoiceModal();
        },


    },
    destroyed() {},
    mounted() {
        window.scrollTo(0, 0);
    },
    computed: {
        
        netAmountCalculate: function () {
            let totalDiscount = this.totalGeneralDiscount + this.totalExtraDiscount + this.totalFlatDiscount;

            let totalVatTax = 0;
            let result = parseFloat(this.totalCartValue + totalVatTax - totalDiscount).toFixed(2);
            this.form.grand_total = result;   
            this.form.total_amount = parseFloat(this.totalCartValue).toFixed(2);
            return parseFloat(result).toFixed(2);
        },
        totalCartValue: function () {
            return this.form.ptest_items.reduce(function (total, item) { 
                return total + item.price * item.qty;
            }, 0);
        },

        totalDiscountPercent: function () {
            return this.discount_items.reduce(function (total, item) { 
                if(item.is_checked) {
                    return total + parseFloat(item.discount_percent);
                }else{ 
                    return total + 0;
                }
            }, 0);
        },

        totalExtraDiscountPercent: function () {
            return this.discount_items.reduce(function (total, item) { 
                if(!item.name.toLowerCase().includes('general') && item.is_checked) {
                    return total + parseFloat(item.discount_percent);
                }else{ 
                    return total + 0;
                }
            }, 0);
        },

        totalGeneralDiscount: function () {
            let generalDiscountPercent = this.totalDiscountPercent - this.totalExtraDiscountPercent;
            let extraDiscountPercent = this.totalExtraDiscountPercent;
            return this.form.ptest_items.reduce(function (total, item) {
                if(item.discount >= generalDiscountPercent) {
                    return total + (((item.price * item.qty) * generalDiscountPercent) / 100);
                }else{
                    let disc_percent = item.discount - extraDiscountPercent;
                    disc_percent = disc_percent < 0 ? 0 : disc_percent;
                    return total + (((item.price * item.qty) * (disc_percent)) / 100);
                }
            }, 0);
        },

        totalExtraDiscount: function () {
            let generalDiscountPercent = this.totalDiscountPercent - this.totalExtraDiscountPercent;
            let extraDiscountPercent = this.totalExtraDiscountPercent;
            return this.form.ptest_items.reduce(function (total, item) {
                if(item.discount > generalDiscountPercent && item.discount > 0) {
                    return total + (((item.price * item.qty) * (item.discount - generalDiscountPercent)) / 100);
                }else{
                    return total + (((item.price * item.qty) * (extraDiscountPercent)) / 100);
                }
            }, 0)
        },

        totalDiscountPercent: function () {
            return this.discount_items.reduce(function (total, item) { 
                if(item.is_checked) {
                    return total + parseFloat(item.discount_percent);
                }else{ 
                    return total + 0;
                }
            }, 0);
        },

        totalFlatDiscount: function () {
            return this.discount_items.reduce(function (total, item) { 
                if(item.is_checked) {
                    return total + parseFloat(item.discount_flat_val ? item.discount_flat_val : 0);
                }else{ 
                    return total + 0;
                }
            }, 0);
        },

        // totalExtraFlatDiscount: function () {
        //     let generalFlatDiscount = this.totalFlatDiscount;
        //     let item_discount =  this.form.ptest_items.reduce(function (total, item) { 
        //         return total + parseFloat(item.flat_discount ? item.flat_discount : 0);
        //     }, 0);
        //     return (item_discount - generalFlatDiscount) < 0 ? 0 : (item_discount - generalFlatDiscount);
        // },

        // totalSpecialFlatDiscount: function () {
        //     return this.totalFlatDiscount + this.totalExtraFlatDiscount;
        // },
    }
}
</script>
<style scoped>
    .modal-content.scrollbar-width-thin {
        border: none !important;
    }

    label {
        display: inline-block;
        margin: 0px 0px 4px 2px;
        float: left;
    }

    .invalid-feedback {
        display: block;
        width: 100%;
        margin-top: 0.25rem;
        font-size: 80%;
        color: #dc3545;
        text-align: left;
    }

    #newBilling hr {
        margin-top: 0px !important;
    }

    .wpr_general_sign_title {
        width: 100%;
        display: block;
        padding: 8px 20px;
        background-color: #313A46;
        display: block;
        color: #fff;
        font-weight: 700;
        font-size: 18px;
    }

    
    /** Autocomplete */
    .autocomplete {
        position: relative;
    }

    ul.autocomplete-results {
        width: 100% !important;
        margin-top: 1px !important;
        position: absolute;
        left: 0;
        z-index: 999;
    }
    .autocomplete-results {
        padding: 0;
        margin: 0;
        border: 1px solid #eeeeee;
        /* height: 120px; */
        overflow: auto;
        width: 100%;
    }

    .autocomplete-results li{
        list-style: none;
        text-align: left;
        padding: 4px 2px;
        cursor: pointer;
    /* background: red; */
    }

    .autocomplete-results li.is-active,
    .autocomplete-results li:hover {
        background-color: #4AAE9B;
        color: white;
    }
    .autocomplete-results li:first-child {
        font-weight: 600;
        border-bottom: 1px solid #282828;
        margin-bottom: 3px;
    }
    .autocomplete-results li:first-child:hover {
        background-color: inherit;
        color: inherit;
    }

    .is-active {
        background-color: #dedede;
    }

    ul.discount_items {
        list-style: none;
        padding: 0;
    }

    ul.discount_items li {
        display: block;
        margin-right: 5px;
        clear: both;
    }

    ul.discount_items li .discount_fields .item_field input{
        margin-bottom: 5px;
    }

    /** For Invoice modal css */
    .modal-content.scrollbar-width-thin.invoice-modal {
        width: 100%;
        display: block;
        margin: auto;
    }

    .invoice-billing {
        font-family: Verdana, Geneva, Tahoma, sans-serif;
    }

    .invoice-billing #top h2{
        font-size: 18px;
    }

    .invoice-billing #top h5{
        font-size: 14px;
    }

    .invoice-billing #top p{
        font-size: 14px;
    }

    .invoice-billing #mid {
        margin-bottom: 10px;
    }

    #mid .info {
        border: 1px solid #282828;
        padding: 0 10px 5px 10px;
        border-radius: 10px;
        margin-bottom: 10px;
    }

    #mid .info table {
        width: 100%;
    }

    #mid .info table tr td{
        font-size: 14px;
    }

    #mid .info table tr td#pname {
        font-weight: 550;
        font-size: 15px;
        text-transform: uppercase;
    }

    #bot .items-info table thead {
        border: 1px solid #282828;
        font-size: 14px;
    }

    #bot .items-info table thead td{
        padding: 5px 10px;
    }

    #bot .items-info table tbody tr{
        border-bottom: 1px solid #e0e0e0;
    }
    #bot .items-info table tbody td{
        padding: 3px 10px;
        font-size: 14px;
    }

    .corporate-payment-info {
        margin-top: 10px;
    }

    .corporate-info p{
        font-size: 14px;
    }

    .payment-info {
        width: 100%;
        border: none;
    }

    .payment-info tr {
        border-bottom: 0 !important;
    }

    .payment-info tr td{
        padding: 3px 10px;
        font-size: 14px;
        border: 0 !important;
        border-top: 0 !important;
        border-bottom: 0 !important;
    }

    .status-signatures {
        margin-top: 10px;
    }

    .status-info h3 {
        font-size: 18px;
    }

    .status-info h3 span {
        padding: 5px; 
        font-size: 22px;
        border: 1px solid #282828; 
        border-radius: 0px;
    }

    .status-info span {
        font-size: 11px;
    }

    .signature-info {
        text-align: center;
    }
    .signature-info h4 {
        text-align: center;
        font-size: 16px;
        border-bottom: 2px solid #e0e0e0;
        margin-bottom: 5px;
        padding-bottom: 2px;
    }

    .signature-info span {
        font-size: 14px;
        text-align: center;
    }

    .room-info {
        margin-top: 10px;
    }

    .room-info p {
        font-size: 13px;
    }

    .room-info p span {
        padding: 5px 10px;
        font-size: 13px;
        margin-right: 5px;
        border: 1px solid #282828;
        border-radius: 0;
    }

    .legal-info {
        margin-top: 10px;
    }

    .legal-info h6 {
        text-align: center;
        font-size: 13px;
        margin-top: 0;
        margin-bottom: 7px;
    }


    
    .input-group.input-group-merge {
        height: 38px;
    }
    .input-group-text {
        height: 40px;
    }

</style>